import { setTrackingOp, useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { STEP_KEY_V2 } from "../../../../util/varibles/constants";
import { stepNameV2 } from "../../../../util/varibles/global";
import { IActivityLog } from "../../../../util/varibles/interface";
import { AutoModeStatus } from "../AutoModeStatus";
import NextTabButton from "../NextTabButton";
import Steps from "../Steps";
import ArrivedStep from "./_Arrived";
import CompletedStep from "./_Completed";
import TreatingStep from "./_Treating";

function StepView({ activity_log, step }: { activity_log: IActivityLog[], step: number }) {
    const set = setTrackingOp();
    const log = activity_log[step];

    switch (log?.key) {
        case STEP_KEY_V2.ARRIVED: {
            return <>
                <ArrivedStep log={log} />
                <NextTabButton
                    name={stepNameV2(STEP_KEY_V2.TREATING)}
                    onClick={() => {
                        const index = activity_log.findIndex(item => item.key === STEP_KEY_V2.TREATING);
                        if (index !== -1) {
                            set({ step: index });
                        }
                    }}
                />
            </>
        }
        case STEP_KEY_V2.TREATING: {
            return <>
                <TreatingStep log={log} stepIndex={step} />
            </>
        }
        case STEP_KEY_V2.COMPLETED: {
            const arrived = activity_log.find(item => item.key === STEP_KEY_V2.ARRIVED);
            return <>
                <CompletedStep log={log} arrived={arrived} stepIndex={step} />
            </>
        }
        default:
            return <></>
    }
}

export default function TreatmentSteps() {
    const [activity_log = []] = useTrackingOp(state => state.op?.activity_log);
    const [step] = useTrackingOp(state => state.step);

    return <div className="w-full h-full flex flex-col px-[20px]">
        <Steps activity_log={activity_log} step={step} />
        <div className="pt-3 w-full relative h-full flex-1">
            <AutoModeStatus />
            <StepView activity_log={activity_log} step={step} />
        </div>
    </div>
}